import React from "react";
import ReactDOM from "react-dom";

import { observer, inject, Provider } from "mobx-react";
import { extendObservable } from 'mobx';

import QuantityList from './QuantityList'
import ProductList  from './ProductList'
import PriceList    from './PriceList'

import styles from './Overview.module.css';


@inject('core')
@observer
export default class Overview extends React.Component {
	
	componentDidMount() {
		const { core } = this.props
	}

	render() {
		const { core } = this.props
		
		return <div className={styles.overview}>
			<h2>{core.products.length} Products in {core.stores.length} Stores</h2>
			<div>
				<div className={styles.column}><QuantityList /></div>
				<div className={styles.column}><ProductList /></div>
				<div className={styles.column}><PriceList /></div>
			</div>
		</div>
	}
	
}
